import 'angular';
import {IModalScope} from "../../../types/angular-types";
import './approval_action_modal.html';
import {ApprovalInfo, ApprovalActionType, ApprovalLevelConfig, ApprovalService} from "../../approvals-types";
import {RootScope} from '../../../types/angular-types';
import SignalProvider from '../../../gorillaboy/SignalProvider';

import {find} from 'lodash-es';

interface IScope extends IModalScope {
    formData: {
        selectedAction: ApprovalActionType
        comment: string
    };
    modalDescription: string;
    currentLevelConfig: ApprovalLevelConfig;

    onOkClicked: () => void;
}

ApprovalActionModalControllerFn.$inject = ['$scope', '$rootScope', '$log', '$translate', 'approvalRequest', 'ApprovalService', 'MessageManager'];
angular.module("GorillaBoy.Approvals")
.controller('ApprovalActionModalController', ApprovalActionModalControllerFn);

function ApprovalActionModalControllerFn($scope: IScope, $rootScope: RootScope, $log: ng.ILogService, $translate: ng.translate.ITranslateService, approvalRequest: ApprovalInfo, ApprovalService: ApprovalService, MessageManager: any) {
    // initialize view model
    $scope.formData = {
        selectedAction: ApprovalActionType.APPROVE,
        comment: ''
    };

    $scope.currentLevelConfig = find(approvalRequest.LevelConfigs, (levelConfig)=> levelConfig.LevelNumber === approvalRequest.CurrentLevel);

    $scope.modalDescription = $translate.instant('APPROVALS.ACTION_MODAL.DESCRIPTION', {minimumApprovalsRequired: $scope.currentLevelConfig.MinimumApprovalsRequired, alphabet: $scope.currentLevelConfig.LevelNumber});
    
    // methods
    $scope.onOkClicked = () => {
        ApprovalService.CreateApprovalAction(approvalRequest, $scope.formData.selectedAction, $scope.formData.comment, null).then(() => {
            $rootScope.$broadcast(SignalProvider.Approval.view.updateApprovalRequest);
            $scope.$close();
        }, (error) => {
            MessageManager.addErrorMessage($translate.instant('APPROVALS.ACTION_MODAL.ACTION_FAILED'));
            $log.error('Failed to take action on ' + approvalRequest.Id + '. Error message: ' + JSON.stringify(error));
        });
    }


    // Helper functions


}
